<template>
  <div
    class="tabs-item"
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
    :style="paddingCalculator"
  >
    <div class="inner">
      <div class="content container">
        <div class="catalogue-head head-cont flex-box between">
          <h3 class="catalogue-ttl  tbc-medium  font-38">
            {{ _.get(contentData, `conf.header.title`) }}
          </h3>
          <div class="catalogue-head-right flex-box">
            <a
              v-if="_.get(contentData, `conf.header.full_list_url`)"
              :href="_.get(contentData, `conf.header.full_list_url`)"
              target="_blank"
              class="link flex-center font-16 text-user-select"
              >{{ _.get(contentData, `conf.header.full_list_title`) }}</a
            >
          </div>
        </div>

        <div class="items">
          <report-card
            :key="index"
            :product="report"
            v-for="(report, index) in reports"
          />
        </div>
        <transition name="toggleContent" mode="out-in">
          <div class="items more-items" v-if="moreLength > 6">
            <report-card
              :key="index"
              :product="report"
              v-for="(report, index) in loadedMoreReports"
            />
          </div>
        </transition>

        <button
          class="more tbc-medium font-16 uppercase"
          v-if="
            _.size(_.get(contentData, 'data.list')) > 5 &&
              moreLength < _.size(_.get(contentData, 'data.list'))
          "
          @click="moreLength = moreLength + 6"
        >
          {{ $fn.tr("LOAD MORE") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ReportCard from "./ReportCard.vue";
export default {
  props: ["contentData", "evenOdd"],
  data() {
    return {
      more: false,
      moreLength: 6
    };
  },
  components: { ReportCard },
  computed: {
    reports() {
      let reports = _.get(this.contentData, "data.list");
      return reports?.slice(0, 6);
    },
    loadedMoreReports() {
      let reports = _.get(this.contentData, "data.list");
      return reports?.slice(6, this.moreLength);
    }
  }
};
</script>

<style scoped>
.tabs-item .inner {
  padding-top: 40px;
  padding-bottom: 40px;
}
.tabs-item .inner .content .head-cont {
  display: flex;
  margin-bottom: 30px;
  align-items: center;
}
.tabs-item .inner .content .head-cont .link {
  color: #00a3e0;
}
.tabs-item .inner .content .more {
  display: flex;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 30px;
  padding-right: 30px;
  justify-content: center;
  align-items: center;
  background-color: #6c7a8a;
  border-radius: 6px;
  color: #ffffff;
  margin: 0 auto;
  margin-top: calc(60px - 30px);
  transition: 0.4s ease;
}
.tabs-item .inner .content .more:hover {
  background: var(--tbc-blue);
  color: #364756;
}
.more-items {
  margin-top: 30px;
}
.tabs-item .inner .content .items {
  display: grid;
  grid-template-columns: repeat(2, minmax(0px, 1fr));
  grid-gap: 30px;
}
.tabs-item .items >>> .report-card {
  width: 100%;
}
.catalogue-ttl {
  color: var(--secondary);
}
@media (max-width: 1023px) and (min-width: 768px) {
  .catalogue-head-right {
    max-width: 50%;
    text-align: end;
    line-height: 24px;
  }
  .catalogue-ttl {
    max-width: 55%;
  }
}
@media (max-width: 767px) {
  .catalogue-ttl.font-38 {
    font-size: 16px;
  }

  .tabs-item >>> .report-card {
    width: 100%;
  }
  .tabs-item .inner .content .items {
    grid-template-columns: repeat(1, minmax(0px, 1fr));
  }
  .tabs-item .inner .content .head-cont {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .catalogue-ttl {
    max-width: 60%;
    margin-bottom: 10px;
  }
}
</style>
